var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-form__item quill-wrapper" },
    [
      _c("input", {
        ref: "upload",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: { change: _vm.onUploadImage },
      }),
      _c("quill-editor", {
        ref: "myQuillEditor",
        attrs: {
          content: _vm.model[_vm.schema.model],
          disabled: !_vm.editPermission,
          options: _vm.editorOption,
        },
        on: { change: _vm.onEditorChange },
      }),
      _vm.inputError
        ? _c(
            "span",
            { staticClass: "error-message" },
            [
              _c("icon", { attrs: { icon: "status-error" } }),
              _vm._v(" " + _vm._s(_vm.uploadErrorMessage) + " "),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }